import { call } from 'redux-saga/effects';
import { RTCClient } from 'utils/webrtc';

export function* stopLocalScreenshareSaga() {
  yield call(RTCClient.screensharingFeed.stopScreenshare);
}
